export const distanceFilter = {
  min: 1,
  max: 100,
  step: 1,
  unit: 'km',
  minLabel: '1km',
  maxLabel: '100km',
} as const;
